import { IconPropsType } from '..';

export const CryptoIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.96056 12.0277C4.48031 12.5426 5.10148 12.8001 5.82406 12.8001L5.99995 12.8001V14.4001H7.59995V12.8001H8.39995V14.4001H9.99995V12.8L10.1758 12.8001C10.8984 12.8001 11.5196 12.5426 12.0393 12.0277C12.5464 11.4999 12.8 10.8691 12.8 10.1353L12.8 8.8001H11.2V10.4001C11.2 10.8001 10.8 11.2001 10.4 11.2001H5.59995C5.19995 11.2001 4.79995 10.8001 4.79995 10.4001V5.6001C4.79995 5.2001 5.19995 4.8001 5.59995 4.8001H10.4C10.8 4.8001 11.2 5.2001 11.2 5.6001V7.2001H12.8L12.7999 5.86493C12.7999 5.13113 12.5464 4.50033 12.0393 3.97251C11.5196 3.45757 10.8984 3.2001 10.1758 3.2001H9.99995V1.6001H8.39995V3.2001H7.59995V1.6001H5.99995V3.20008H5.82406C5.10148 3.20008 4.48031 3.46399 3.96056 3.99181C3.45349 4.50675 3.19995 5.13112 3.19995 5.86491V10.1353C3.19995 10.869 3.45349 11.4999 3.96056 12.0277Z"
      fill="current"
    />
  </svg>
);
